import React, { useEffect, useState } from "react";
import apiCategories from "../../../api/categories";
import { useSelector } from "react-redux";
import { Button, Container, Table } from "react-bootstrap";
import TextInput from "../../../components/TextInput/TextInput";
import { PencilSquare, ArrowUpSquareFill } from "react-bootstrap-icons";
import CheckSphere from "../../../components/CheckSphere/CheckSphere";
import PseudoTable from "../../../components/PseudoTable/PseudoTable";

import Spinner from "../../../components/Spinner/Spinner";
import classes from "./CategoriesList.module.css";

import handleApiErrors from "../../../utilities/handleApiErrors";
import PaginationItem from "../../../components/PaginationItem/PaginationItem";
import stringSimilarity from "string-similarity";
import useInfiniteScroll from "../../../utilities/useInfiniteScroll";

const states = {
  LOADING: "LOADING",
  LOADED: "LOADED",
  ERROR: "ERROR",
};
const resultsNumber = 20;

const CategoriesList = (props) => {
  const accesToken = useSelector((state) => state.user.access);

  const [inputValue, setInputValue] = useState("");

  const [allCategories, setAllCategories] = useState([]);
  const [allCategoriesUntouched, setAllCategoriesUntouched] = useState([]);
  // States for pagination
  const [pageNumber, setPageNumber] = useState(0);
  // const [showPaginationUnder, setShowPaginationUnder] = useState(true)
  // const [errorState, setErrorState] = useState(false);

  const [process, setProcess] = useState(states.LOADING);

  // INFINITE SCROLL
  const [results, setResults] = useState(20);
  const [isFetching, setIsFetching] = useInfiniteScroll(fetchMoreListItems);

  //Bring data to make the list of categories
  useEffect(() => {
    apiCategories
      .listAll(accesToken)
      .then(({ data }) => {
        const items = data.map((item) => ({
          id: item.id,
          name: item.name,
          active: item.active,
        }));

        setAllCategories(items);
        setAllCategoriesUntouched(items);
        setProcess(states.LOADED);
      })
      .catch((e) => {
        handleApiErrors(e);
      });
  }, []);

  // * FUNCTION FOR THE SCROLL INFINITE
  function fetchMoreListItems() {
    setTimeout(() => {
      if (results + 20 > allCategories.length) {
        setResults(allCategories.length);
      } else {
        setResults(results + 20);
      }
      setIsFetching(false);
    }, 500);
  }
  // Edit category
  const editCategory = (pId) => {
    props.history.push(`/category/${pId}`);
  };

  // Split arrays function
  const splitArrays = (arr, len) => {
    var chunks = [],
      i = 0,
      n = arr.length;
    while (i < n) {
      chunks.push(arr.slice(i, (i += len)));
    }
    return chunks;
  };

  // * LOGIC FROM SIMILARITY ALGORITHMN
  useEffect(() => {
    const queryedItems = allCategories.map((item) => {
      const scoredItem = {
        ...item,
        score: stringSimilarity.compareTwoStrings(
          inputValue.toLocaleLowerCase(),
          item.name.toLocaleLowerCase()
        ),
      };
      return scoredItem;
    });
    const arrayfilteredSorted = queryedItems.sort((a, b) => {
      if (a.score > b.score) {
        return -1;
      }
      if (a.score < b.score) {
        return 1;
      }
      return 0;
    });

    const exactItems = [];
    const similarItems = [];

    arrayfilteredSorted.forEach((product) => {
      if (product.name.toLocaleLowerCase().includes(inputValue)) {
        exactItems.push(product);
      } else {
        similarItems.push(product);
      }
    });
    // When there are 3 letters or more then it shows the flitered/ordered array, if not the general array
    inputValue.length > 2
      ? setAllCategories([
          ...exactItems,
          ...similarItems.filter((item) => item.score > 0.1),
        ])
      : setAllCategories(allCategoriesUntouched);
  }, [inputValue]);

  //  * LOGIC FOR RESPONSIVE, IF MATCH WITH THE MOBILE SCREEN THE RESULTS PER PAGE ADD 20 RESULTS AVERY TIME SCROLL TO THE END OF THE VIEWPORT
  let breakPointResponsive = window.matchMedia("(max-width: 65em)");
  let bodyContent;
  function responsiveBreakMatch(breakPointResponsive) {
    // If media query matches, the type of results change to the state
    bodyContent =
      splitArrays(
        allCategories,
        breakPointResponsive.matches ? results : resultsNumber
      )[pageNumber] === undefined
        ? null
        : splitArrays(
            allCategories,
            breakPointResponsive.matches ? results : resultsNumber
          )[pageNumber].map((item, index) => {
            return (
              <>
                {/* <ReactTooltip place="left" type="info" /> */}

                <PseudoTable.Row key={item.id} className={classes.row}>
                  <div>{item.id}</div>
                  <div>
                    <p>{item.name}</p>
                  </div>
                  <div>
                    <CheckSphere check={item.active} x={!item.active} />
                  </div>
                  <div>
                    <Button
                      variant="light"
                      onClick={() => editCategory(item.id)}
                      // disabled={props.processing}
                    >
                      <PencilSquare />
                    </Button>
                  </div>
                </PseudoTable.Row>
                {breakPointResponsive.matches && allCategories.length > 20 ? (
                  results <= 20 ? null : (
                    <div className={classes.arrowContainer}>
                      <ArrowUpSquareFill
                        // data-tip="Volver al inicio"
                        className={classes.arrowUp}
                        onClick={() => {
                          window.scrollTo(0, 0);
                        }}
                      />
                    </div>
                  )
                ) : null}
              </>
            );
          });
  }
  responsiveBreakMatch(breakPointResponsive);

  return (
    <>
      {/* Title */}
      <Container className={classes.title}>
        <h1>Lista de categorías</h1>
      </Container>

      <Container className={classes.input}>
        <TextInput
          placeholder="Introduce el nombre de la categoría"
          onChange={(event) => {
            setInputValue(event.target.value);
            setPageNumber(0);
          }}
          value={inputValue}
        />
      </Container>

      {/* Table */}
      <Container>
        {process === "LOADING" ? (
          <Spinner
            className="mt-5"
            as="svg"
            animation="border"
            size="lg"
            role="status"
            aria-hidden="true"
          />
        ) : (
          <>
            {/* // PAGINATION */}
            {allCategories.length >= 10 ? (
              <PaginationItem
                //Pongo el mismo array en filtrado para que no cambie la paginación ni de error
                arrayWhole={allCategories}
                resultsNumber={resultsNumber}
                setPageNumber={setPageNumber}
                pageNumber={pageNumber}
                inputValue={inputValue}
              />
            ) : null}
            {/* //END OF PAGINATION */}

            <PseudoTable.Table>
              <PseudoTable.Header className={classes.header}>
                <div>ID</div>
                <div>NOMBRE</div>
                <div>ACTIVO</div>
                <div>EDITAR</div>
              </PseudoTable.Header>
              {bodyContent}
            </PseudoTable.Table>
            {/* //* SPINNER IN MOBILE WHEN LOADING MORE ITEMS */}
            {isFetching ? (
              <div className={classes.hideSpinnerDesktop}>
                <Spinner
                  as="svg"
                  animation="border"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                />
              </div>
            ) : null}
            {/* // BOTTOM PAGINATION */}
            {allCategories.length >= 10 ? (
              <PaginationItem
                //Pongo el mismo array en filtrado para que no cambie la paginaciòn ni de error
                arrayWhole={allCategories}
                resultsNumber={resultsNumber}
                setPageNumber={setPageNumber}
                pageNumber={pageNumber}
                inputValue={inputValue}
              />
            ) : null}
            {/* //END OF BOTTOM PAGINATION */}
          </>
        )}
      </Container>
    </>
  );
};

export default CategoriesList;
